<br><br>
<!-- Titre Cantine -->
  <div class="text-center mb-0">
    <app-page-title [titleKey]="'canteen.title'"></app-page-title>
  </div>
  <app-loader [isLoading]="loading"></app-loader>

<!-- contenu -->
<div *ngIf="!loading">
  <!-- Sélecteur d'enfants -->
  <app-children-selector
    [(selectedStudentId)]="selectedStudentId"
    (studentSelected)="onStudentSelected($event)"
    (studentsLoaded)="onStudentsLoaded($event)"
  ></app-children-selector>

  <div class="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 p-6">
    <div class="cantine-container p-4 rounded-2xl shadow-lg bg-white max-w-3xl mx-auto relative">

      <!-- Bouton Retour (visible uniquement dans la section réservation) -->
      <button
        (click)="showReservationSection = false; showForm = false"
        class="px-4 py-2 bg-gray-500 text-white rounded-lg shadow hover:bg-gray-600 transition mt-4"
        *ngIf="showReservationSection">
        ← {{ 'canteen.backToMenu' | translate }}
      </button>

      <!-- Boutons Réserver / Mes réservations -->
      <div class="flex gap-2 mt-4 mb-6" *ngIf="!showReservationSection">
        <button
          (click)="setMode(false)"
          class="px-4 py-2 bg-[#49BBBD] text-white rounded-lg shadow hover:bg-[#3aa3a5] transition">
          {{ 'common.reserve' | translate }}
        </button>

        <button
          (click)="setMode(true)"
          class="px-4 py-2 bg-[#49BBBD] text-white rounded-lg shadow hover:bg-[#3aa3a5] transition">
          {{ 'canteen.myReservations' | translate }}
        </button>
      </div>

      <!-- Section Réservation / Recherche -->
      <div *ngIf="showReservationSection">

        <!-- Formulaire: Ajouter réservation -->
        <form *ngIf="showForm && !isSearchForm" (ngSubmit)="reserver()" #reservationForm="ngForm" class="reservation-form mb-6">
          <div class="input-wrapper">
            <input type="date" id="startdateAdd" name="startdateAdd" [(ngModel)]="reservation.dateDebut" required placeholder="{{ 'canteen.startDate' | translate }}" />
            <span class="icon"><img src="../../assets/icons/calendar.jpg" alt="Calendrier"></span>
          </div>
          <div class="input-wrapper">
            <input type="date" id="enddateAdd" name="enddateAdd" [(ngModel)]="reservation.dateFin" required placeholder="{{ 'canteen.endDate' | translate }}" />
            <span class="icon"><img src="../../assets/icons/calendar.jpg" alt="Calendrier"></span>
          </div>
          <div class="input-wrapper">
            <select id="typeAdd" name="typeAdd" [(ngModel)]="reservation.type" required>
              <option value="" disabled>{{ 'canteen.chooseMealType' | translate }}</option>
              <option value="Cantine">{{ 'canteen.canteen' | translate }}</option>
              <option value="Gouter">{{ 'canteen.snack' | translate }}</option>
            </select>
            <span class="icon"><img src="../../assets/icons/cantine.png" alt="Type de repas"></span>
          </div>
          <button type="submit" class="submit-btn">{{ 'canteen.register' | translate }}</button>
        </form>

        <!-- Formulaire: Rechercher réservations -->
        <form *ngIf="showForm && isSearchForm" (ngSubmit)="rechercherReservations()" #searchForm="ngForm" class="reservation-form mb-3">
          <div class="input-wrapper">
            <input type="date" id="startdateSearch" name="startdateSearch" [(ngModel)]="searchCriteria.dateDebut" placeholder="{{ 'canteen.startDate' | translate }}" />
            <span class="icon"><img src="../../assets/icons/calendar.jpg" alt="Calendrier"></span>
          </div>
          <div class="input-wrapper">
            <input type="date" id="enddateSearch" name="enddateSearch" [(ngModel)]="searchCriteria.dateFin" placeholder="{{ 'canteen.endDate' | translate }}" />
            <span class="icon"><img src="../../assets/icons/calendar.jpg" alt="Calendrier"></span>
          </div>
          <div class="input-wrapper">
            <select id="typeSearch" name="typeSearch" [(ngModel)]="searchCriteria.type" (change)="applySearchFilter()">
              <option value="" disabled>{{ 'canteen.chooseMealType' | translate }}</option>
              <option value="Cantine">{{ 'canteen.canteen' | translate }}</option>
              <option value="Gouter">{{ 'canteen.snack' | translate }}</option>
            </select>
            <span class="icon"><img src="../../assets/icons/cantine.png" alt="Type de repas"></span>
          </div>
          <button type="submit" class="submit-btn bg-green-500 hover:bg-green-600 mt-2">
            {{ 'canteen.search' | translate }}
          </button>
        </form>

        <!-- Tableau des réservations (uniquement en mode recherche) -->
        <div *ngIf="isSearchForm && reservations.length > 0" class="mt-2">
          <table class="min-w-full border border-gray-300 text-left text-sm">
            <thead class="bg-gray-200">
              <tr>
                <th class="px-2 py-1 border">{{ 'canteen.startDate' | translate }}</th>
                <th class="px-2 py-1 border">{{ 'canteen.type' | translate }}</th>
                <th class="px-2 py-1 border">{{ 'actions.actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let res of (isSearchForm ? filteredReservations : reservations) | slice: (currentPage-1)*pageSize : currentPage*pageSize" class="hover:bg-gray-100">
                <td class="px-2 py-1 border">{{ res.datedebut || 'N/A' }}</td>
                <td class="px-2 py-1 border">{{ res.typeReservation | lowercase }}</td>
                <td class="px-2 py-1 border flex justify-center items-center">
                  <button (click)="supprimer(res)" class="px-3 py-1 bg-[#E32B0E] text-white rounded flex items-center gap-2 hover:bg-[#C1270C] transition" title="{{ 'actions.delete' | translate }}">
                    <span>{{ 'actions.delete' | translate }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 6h18M9 6v12m6-12v12M5 6l1 14a2 2 0 002 2h8a2 2 0 002-2l1-14M10 6h4"/>
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <div class="flex justify-between items-center mt-4">
            <button (click)="prevPage()" [disabled]="currentPage === 1" class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 disabled:opacity-50">
              {{ 'canteen.previous' | translate }}
            </button>
            <span>Page {{ currentPage }} / {{ totalPages() }}</span>
            <button (click)="nextPage()" [disabled]="currentPage === totalPages()" class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 disabled:opacity-50">
              {{ 'canteen.next' | translate }}
            </button>
          </div>
        </div>

        <!-- Aucune réservation (uniquement en mode recherche) -->
        <div *ngIf="isSearchForm && reservations?.length === 0" class="p-4 bg-gray-100 rounded-lg text-gray-600 mt-4">
          {{ 'canteen.noReservations' | translate }}
        </div>

      </div>

      <!-- MENU DU JOUR (affiché uniquement si pas dans la section réservation) -->
      <div *ngIf="!showReservationSection">
        <h2 class="cantine-title text-xl font-bold mb-4">{{ 'canteen.dailyMenu' | translate }}</h2>

        <!-- Image du menu si disponible -->
        <div *ngIf="menuImage?.path" class="mb-4 menu-image-wrapper">
          <img [src]="menuImage.path" 
               [alt]="menuImage.arName || 'Menu du jour'" 
               class="menu-image w-full rounded-lg shadow-md object-contain">
          <p *ngIf="menuImage.arName" class="mt-2 text-gray-600 text-sm italic">{{ menuImage.arName }}</p>
          <p *ngIf="menuImage.description" class="text-gray-600 text-sm">{{ menuImage.description }}</p>
        </div> 


        <div *ngIf="loading" class="cantine-message loading mb-4">{{ 'canteen.loadingMeals' | translate }}</div>
        <div *ngIf="error" class="cantine-message error mb-4">{{ error }}</div>
        <div *ngIf="!loading && !error && cantineData.length > 0">
          <!-- Sélecteur de jour -->
          <div class="day-selector flex items-center justify-center gap-4 mb-4">
            <button (click)="prevDay()" [disabled]="currentIndex === 0" class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300">&larr;</button>
            <span class="day-label font-semibold">{{ capitalizeFirstLetter(formatDate(cantineData[currentIndex].date)) }}</span>
            <button (click)="nextDay()" [disabled]="currentIndex === cantineData.length - 1" class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300">&rarr;</button>
          </div>

          <!-- Menu du jour -->
          <div *ngFor="let type of cantineData[currentIndex].cantine" class="mb-4">
            <h3 class="font-semibold mb-1">{{ type.type }}</h3>
            <ul class="list-disc list-inside">
              <li *ngFor="let item of type.list">{{ item.name }}</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>